import React from "react";
import { connect } from "react-redux";
import { database } from "../app-database";
import Modal from '../generalcomponets/modal-mobile';

const mapState = (state) => {
	return {
		mensajes: state.modal.listaMensajes,
		visible: state.modal.visible,
		titulo: state.modal.titulo,
		mensaje: state.modal.mensaje,
		codigo: state.modal.codigo,
		accion: state.modal.accion,
		nameBtnCancel: state.modal.nameBtnCancel,
		accionCancel: state.modal.accionCancel,
		nameBtnConfirm: state.modal.nameBtnConfirm,
		accionConfirm: state.modal.accionConfirm,
		dispositivo: state.global.dispositivo,
	};
};

const mapDispatch = (dispatch) => {
	return {
		listaMensajes: (oLista) => {
			dispatch({ "type": "MODAL_ALERT_LISTA", "listaMensajes": oLista });
		},
		actualizaMensajes: (sTitulo, sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES", "titulo": sTitulo, "mensaje": sMensaje });
		},
		ocultar: () => {
			dispatch({ "type": "MODAL_ALERT_HIDE" });
			//dispatch({ "type": "MODAL_ALERT_RESET" });
		}
	};
};

class ModalAlert extends React.Component {

	state = {
		isModalOpened: true,
		modalMesage:{type: null, message: null}
	}

	action = (prop) => {
		if (typeof this.props[prop] == "function") {
			this.props[prop]();
		} else {
			console.log("close modal");
		}
		if(this.props.dispositivo === 'app'){
			this.closeModalFromChild();
		}
		this.props.ocultar();
	}

	getCodeErrorMensaje = (_codigo) => {
		let codigo = _codigo.toUpperCase();
		let mensaje = this.props.mensajes[codigo];
		return (mensaje != undefined)? mensaje : "SERVICIO NO DISPONIBLE";
	}

	showModal = () => {
		$("#modal-message").modal({backdrop: "static", keyboard: false});
	}
	
	componentWillMount = () => {
		if(Object.keys(this.props.mensajes).length == 0) {
			database.ref("catalogos/mensajesError").on("value", oValue => {
				this.props.listaMensajes(oValue.val());
			});
		}
	}

	openModalParent = (type, title, message) => {
		let { isModalOpened } = this.state;

		if(isModalOpened)
		  this.setState({ isModalOpened: false, modalMesage:{ type: null, title: null,  message: null}})
		else{
		  this.setState({ isModalOpened: true, modalMesage:{ type, title, message}});
		}
	}

	closeModalFromChild = () => {
		this.setState({ isModalOpened: false, modalMesage:{ type: null, message: null}})
	}

	renderMensaje = () => {
		if(_.isFunction(this.props.mensaje)){
			return this.props.mensaje();
		}else{
			return <p>{this.props.mensaje}</p>;
		}
	}

	render() {
		if(this.props.dispositivo === 'app'){
			if(this.props.visible === true && this.state.isModalOpened){
				return(
					<Modal closeModalFromChild={() => null}>
						<div className="container">
							<div className="row">
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
									<label className="gnp-material-title-modal">{this.props.titulo}</label>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 margin-modal">
									<p className=" gnp-material-content-modal">{this.renderMensaje()}</p>
								</div>
								{this.props.codigo == "MAC" &&
									<div>
										<div className="col-md-12 col-sm-12 col-xs-12 text-center" style={{marginBottom:"10px"}}>
											<button 
												type="button" 
												onClick={() => { this.action('accionConfirm') }} 
												className="pure-material-button-contained btn-full-width"
												>
													{[undefined, null, ''].includes(this.props.nameBtnConfirm) ? "Confirmar" : this.props.nameBtnConfirm}
											</button>
										</div>
										<div className="col-md-12 col-sm-12 col-xs-12 text-center" style={{marginBottom:"30px"}}>
											<button 
												type="button" 
												onClick={() => { this.action('accionCancel')}}
												className="pure-material-button-outlined btn-full-width"
												>
													{[undefined, null, ''].includes(this.props.nameBtnCancel) ? "Cancelar" : this.props.nameBtnCancel}
												</button>
										</div>
									</div>
								}
								{this.props.codigo != "MAC" &&
									<div className="col-md-12 col-sm-12 col-xs-12 text-center" style={{marginBottom:"10px"}}>
										<button type="button" onClick={() => { this.action('accion')}} className="pure-material-button-contained btn-full-width">Aceptar</button>
									</div>
								}
							</div>
						</div>
					</Modal>	
				)
			} else {
				return null;
			}
		} else {
			return	(
				<div>
					<div className="modal modal-msj fade" id="modal-message" tabIndex="-1" role="dialog" aria-labelledby="id-modal-title">
						<div className="modal-dialog" role="document">
							<div className={this.props.dispositivo === 'app' ? "modal-content alert-movil" : 'modal-content'}>
								<div className="">
									<h5 id="id-modal-title" className="text-center">{this.props.titulo}</h5>
								</div>
								<div className="txt-black">
									<p>{this.renderMensaje()}</p>
								</div>
								{this.props.codigo == "MAC" &&
									<div style={{ width: "unset" }} className="text-center aceptar-cancelar-btn mt-20">
									<button style={{ margin: "3%", width: "unset", border: "1px solid #666666", backgroundColor: "white", color: "#666666", padding: "10px" }} type="button" className="btn" onClick={() => { this.action('accionCancel') }} data-dismiss="modal">{[undefined, null, ''].includes(this.props.nameBtnCancel) ? "Cancelar" : this.props.nameBtnCancel}</button>
									<button style={{ margin: "3%", width: "unset" }} type="button" className="btn orange-btn" onClick={() => { this.action('accionConfirm') }} data-dismiss="modal">{[undefined, null, ''].includes(this.props.nameBtnConfirm) ? "Confirmar" : this.props.nameBtnConfirm}</button>
									</div>
								}
								{this.props.codigo != "MAC" &&
									<div className="text-center aceptar-cancelar-btn mt-20">
									<button type="button" className={this.props.dispositivo === 'app' ? "btn orange-btn btn-alert" : "btn orange-btn"} onClick={() => { this.action('accion') }} data-dismiss="modal">Aceptar</button>
									</div>
								}
							</div>
						</div>
					</div>
					{ this.props.visible == true &&
						<div>
							{ this.showModal() }
						</div>
					}
					<div className="modal modal-msj fade" id="modal-offline" tabIndex="-1" role="dialog" aria-labelledby="id-modal-offline">
						<div className="modal-dialog" role="document">
							<div className="modal-content">
								<div className="">
									<h5 id="id-modal-title" className="text-center">Aviso</h5>
								</div>
								<div className="txt-black">
									<p>Conexión no disponible.</p>
									<p>Por favor, verifica la conexión a internet e intenta de nuevo más tarde.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		}
	}
}

export default connect(mapState, mapDispatch)(ModalAlert);


// WEBPACK FOOTER //
// ./src/modal-alert/modal-alert.cmpt.js